import { Checkbox, FormField, Input, Select } from '@vwfs-bronson/bronson-react';

import { NULLABLE_FIELDS, NUMBER_FIELDS, SELECT_OPTIONS } from './constants.js';
import { isBooleanPath } from './utils.js';

export const ConfigurationField = ({ fieldPath, fieldLabel, value, onChange }) => {
  const flatPath = fieldPath.join('.');
  const id = flatPath.replaceAll('.', '_');
  const options = SELECT_OPTIONS[flatPath];
  const isBoolean = isBooleanPath(fieldPath) || typeof value === 'boolean';
  const isNumber = NUMBER_FIELDS.has(flatPath) || typeof value === 'number';

  if (isBoolean) {
    return (
      <Checkbox
        id={id}
        name={id}
        checked={Boolean(value)}
        onChange={(event) => onChange(fieldPath, event.target.checked)}
      >
        {fieldLabel}
      </Checkbox>
    );
  }

  if (options) {
    const selectValue = value === null ? '__null__' : String(value);

    return (
      <FormField labelForId={id} labelText={fieldLabel} type="select" noFloatingLabel>
        <Select
          id={id}
          value={selectValue}
          onChange={(event) => {
            const option = options.find(
              (item) =>
                String(item.value === null ? '__null__' : item.value) ===
                event.target.value,
            );
            onChange(fieldPath, option ? option.value : null);
          }}
        >
          {options.map((option, index) => (
            <Select.Item
              key={`${id}_option_${index}`}
              value={String(option.value === null ? '__null__' : option.value)}
            >
              {option.label}
            </Select.Item>
          ))}
        </Select>
      </FormField>
    );
  }

  return (
    <FormField labelForId={id} labelText={fieldLabel} type="input" noFloatingLabel>
      <Input
        id={id}
        name={id}
        type={isNumber ? 'number' : 'text'}
        value={value ?? ''}
        onChange={(event) => {
          if (isNumber) {
            if (event.target.value === '') {
              onChange(fieldPath, NULLABLE_FIELDS.has(flatPath) ? null : 0);
              return;
            }
            onChange(fieldPath, Number(event.target.value));
            return;
          }

          if (event.target.value === '' && NULLABLE_FIELDS.has(flatPath)) {
            onChange(fieldPath, null);
            return;
          }

          onChange(fieldPath, event.target.value);
        }}
      />
    </FormField>
  );
};